import { Button, Divider, Popconfirm, Typography } from 'antd';
import { differenceInCalendarDays } from 'date-fns';

import { SubscriptionType } from '@/core/enums/subscriptionType';
import { useAppDispatch, useAppSelector } from '@/core/redux/hooks';
import { subscriptionActions } from '@/core/redux/slices/subscription/slice';
import { usersSelectors } from '@/core/redux/slices/users/selectors';
import { formatToDate } from '@/core/utils/dateUtils';

const { Text, Title } = Typography;

export const SubscriptionInfo: React.FC = () => {
  const user = useAppSelector(usersSelectors.user);
  const dispatch = useAppDispatch();

  const { plan_type, ends_at, payment_method_title, auto_renew, price } =
    user?.subscription || {
      ends_at: '',
      plan_type: 'trial',
    };

  const org_count_days = user?.organization_subscription_ends_at
    ? differenceInCalendarDays(
        new Date(user?.organization_subscription_ends_at),
        new Date()
      )
    : 0;

  const bank_card_data = payment_method_title?.substring(
    payment_method_title.length - 4
  );

  const cancel_auto_renew = () => {
    dispatch(subscriptionActions?.fetchCancelAutoRenewalOfSubscription());
  };

  if (org_count_days > 0 && user?.organization_id) {
    return (
      <div>
        <Title level={5}>Активная подписка</Title>

        <Text>
          Командная, оплачено до{' '}
          {formatToDate(user?.organization_subscription_ends_at || '')}
        </Text>
      </div>
    );
  } else {
    return (
      <div>
        <div>
          <Title level={5}>Активная подписка</Title>

          <Text>
            {SubscriptionType?.[plan_type]}, оплачено до {formatToDate(ends_at)}
          </Text>
        </div>
        <Divider />

        <div className='flex items-center  justify-between'>
          {bank_card_data && (
            <div>
              <Title level={5}>Способ оплаты</Title>
              <div className='flex flex-col '>
                {bank_card_data && (
                  <Text>Банковская карта (••• {bank_card_data})</Text>
                )}
                {auto_renew && (
                  <Text>
                    {formatToDate(ends_at)} будет списано {price} ₽,
                    автопродление включено
                  </Text>
                )}
              </div>
            </div>
          )}

          {auto_renew && (
            <Popconfirm
              title={
                <div className='text-wrap w-[350px]'>
                  Вы уверены, что хотите отключить автопродление, и удалить
                  способ оплаты?
                </div>
              }
              okText='Удалить'
              cancelText='закрыть'
              placement='left'
              onConfirm={cancel_auto_renew}
            >
              <Button type='link'>Удалить</Button>
            </Popconfirm>
          )}
        </div>
      </div>
    );
  }
};
